import { DynamicFormControlLayout, DynamicFormControlModel, DynamicFormControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_ACTION_BUTTON = 'ACTION_BUTTON';

export interface ActionButtonModelConfig extends DynamicFormControlModelConfig {
  icon: string;
  eventName: string;
  hiddenWhenDisabled?: boolean;
}

export class ActionButtonModel extends DynamicFormControlModel {
  @serializable() readonly type: string = TYPE_ACTION_BUTTON;

  @serializable() icon: string;
  @serializable() eventName: string;
  @serializable() hiddenWhenDisabled: boolean;

  // `disabled` and `labelTooltip` from DynamicFormControlModel are also used in the component

  constructor(config: ActionButtonModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.icon = config.icon || null;
    this.eventName = config.eventName || null;
    this.hiddenWhenDisabled = config.hiddenWhenDisabled || null;
  }
}
